module.exports = __webpack_public_path__ + "/70d28f13e03563f29fc6f597884a9148.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/box_logo_white.svg
 ** module id = 1252
 ** module chunks = 0
 **/